import { CARTEIRAS_CHANGED } from "../../const/actionsType";

export function acCarteirasChanged(pObj) {
  return {
    type: CARTEIRAS_CHANGED,
    payload: pObj,
  };
}
